import request from '@/utils/request';
export const reqUserInfo = () => request.post('/getUserInfoByToken');
export const reqLogout = () => request.post('/logout');
export const reqLogin = params => {
    return request.post('/login', params);
};

export function reqRegister(params) {
    return request.post('/register', params);
}

export function reqRegisterCode(params) {
    return request.post('/send', params);
}
export const reqGetSystem = () => request.post('/getSiteInfo');

export function reqAddInfo(params) {
    return request.post('/reqAddInfo', params);
}

// 获取轮播
export const reqGetSlide = () => request.post('/getSlide');
export const reqGetRegion = () => request.post('/reqGetRegion');

// 获取用户是否唯一
export function reqRegisterUserNameIsUnique(params) {
    return request.post('/reqRegisterUserNameIsUnique', params);
}
// 获取 类型下面的
export function reqGetTypeList(params) {
    return request.post('/reqGetTypeList', params);
}

export function reqTypeList() {
    return request.post('/getTypeList');
}

export function reqGetTypeListById(params) {
    return request.get('/reqGetTypeListById', { params });
}

export const reqGetMessageById = id => request.post('/reqGetMessageById', id);
export const reqUploadImage = params => request.post('/uploadImage', params);
export const reqTextareaImageUpload = params => request.post('/reqTextareaImageUpload', params);
export const reqMessageSubmit = params => request.post('/messageSubmit', params);
export const reqGetTypeMessage = () => request.post('/reqGetTypeMessage');
// 更新用户信息
export function reqUpdateUserInfo(params) {
    return request.post('/reqUpdateUserInfo', params);
}

export const reqGetMyPublish = () => request.post('/reqGetMyPublish');
export const reqDelMyPublishMessage = id => request.post('/reqDelMyPublishMessage', id);
export function reqSearch(params) {
    return request.post('/reqSearch', params);
}

export function reqGetArticleById(params) {
    return request.post('/reqGetArticleById', params);
}
export function reqGetArticleHome(params) {
    return request.post('/reqGetArticleHome', params);
}

export function reqGetRecommend(params) {
    return request.post('/reqGetRecommend', params);
}
export function reqGetHomeMessage() {
    return request.post('/reqGetHomeMessage');
}
export function reqGetCountMessage() {
    return request.post('/reqGetCountMessage');
}
